import {CopyableCommand} from './CopyableCommand';
import {installCommand,installPrompt} from './clientTools';

export const NATIVE_INIT_PROMPT = 'Use pabs-init to initialize this project.';
export const nativeInitPrompt = planId => planId ? `Use pabs-init with my existing Pabs project ${planId}.` : NATIVE_INIT_PROMPT;

export function NativePluginEntry({tool,planId,hint=true}) {
  const prompt=installPrompt(tool,installCommand({client:tool.id,planId}));
  return <div className="pabs-install-remote">
    {hint && <p>Paste this into your agent’s chat.</p>}
    <CopyableCommand key={prompt} value={prompt} label="Copy install prompt"/>
  </div>;
}

export default function NativePluginSetup({tool,planId}) {
  return <ol className="pabs-brief-steps">
    <li className="pabs-brief-step" data-state="current"><span className="pabs-brief-step-number" aria-hidden="true">1</span><div className="pabs-brief-step-body">
      <h3>Paste this into {tool.label} to install Pabs</h3><div className="pabs-brief-step-content"><NativePluginEntry tool={tool} planId={planId} hint={false}/></div>
    </div></li>
    <li className="pabs-brief-step" data-state="current"><span className="pabs-brief-step-number" aria-hidden="true">2</span><div className="pabs-brief-step-body">
      <h3>Then ask it to set up your project</h3><div className="pabs-brief-step-content">
        <CopyableCommand value={nativeInitPrompt(planId)} label="Copy initialization prompt"/>
        <p>Connect your Pabs account when asked. Pabs picks up your existing product or helps set up a new one.</p>
      </div>
    </div></li>
  </ol>;
}
